import { useState } from "react";
import { styled } from '@mui/system';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, IconButton, Typography } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SetEspelhoLabelModal from "../../../../components/modais/SetEspelhoLabelModal";
import Terminal from "./Terminal";
import AddTerminalModal from "../../../../components/modais/AddTerminalModal";


const Header = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    width: '100%',
});

const KeyValue = styled(Box)({
    display: 'flex',
    gap: 4,
    alignItems: 'center',
});
const Key = styled(Typography)({
    fontWeight: '500'
});

const EspelhoInfo = styled(Box)({
});

const TerminalHeader = styled(Box)({
});

const TerminalList = styled(Box)({
});

const EspelhoList = ({
    espelhos,
    terminals,
    handleOpenBrowser,
    handleCloseBrowser,
    handleRefreshBrowser,
    handleGetComports,
    handleSetComport,
    handleConnectComport,
    handleCloseComport,
    handleSendDataToComport,
}) => {
    // console.log(espelhos);
    // console.log(terminals);
    const [selectedEspelho, setSelectedEspelho] = useState(null);
    const [openLabelModal, setOpenLabelModal] = useState(false);
    const handleCloseLabelModal = () => {
        setOpenLabelModal(false);
        setSelectedEspelho(null);
    };

    const handleSetLabel = (item, event) => {
        event.stopPropagation();
        console.log(item);
        setSelectedEspelho(item);
        setOpenLabelModal(true);
    }

    const [openAddTerminalModal, setOpenAddTerminalModal] = useState(false);
    const handleCloseAddTerminalModal = () => {
        setOpenAddTerminalModal(false);
        setSelectedEspelho(null);
    };
    const handleAddTerminal = (item, event) => {
        event.stopPropagation();
        console.log(item);
        setSelectedEspelho(item);
        setOpenAddTerminalModal(true);
    }

    const getColor = (status) => {
        if (status === 'Connected') {
            return 'green';
        }
        if (status === 'disconnected') {
            return 'red';
        }
        return '';
    }
    return (
        <div style={{ marginTop: '12px' }}>
            {espelhos.map((item) =>
                <Accordion key={item.Id}>
                    <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls={`panel${item.Id}-content`}
                        id={`panel${item.Id}-header`}
                        sx={{
                            // Override default styles
                            '&.MuiAccordionSummary-root': {
                                width: '100%'
                            },
                        }}
                    >
                        <Header>
                            <Box>{item.Label
                                ?
                                <Typography><strong>{item.Label}</strong></Typography>
                                :
                                <Button variant="text" onClick={(e) => handleSetLabel(item, e)}>Definir nome</Button>
                            }
                            </Box>
                            <KeyValue>
                                <Key>Status: </Key>
                                <Typography sx={{ color: getColor(item.ConnectionStatus) }}>{item.ConnectionStatus}</Typography>
                            </KeyValue>
                        </Header>

                    </AccordionSummary>
                    <AccordionDetails>
                        <EspelhoInfo>
                            <KeyValue>
                                <Key>Identificador: </Key>
                                <Typography>{item.Identifier}</Typography>
                                <IconButton aria-label="copy" onClick={() => { navigator.clipboard.writeText(item.Identifier) }}>
                                    <ContentCopyIcon />
                                </IconButton>
                            </KeyValue>
                        </EspelhoInfo>

                        <TerminalHeader my={2}>
                            <Button variant="contained" color="success" onClick={(e) => handleAddTerminal(item, e)}>Adicionar Terminal</Button>
                        </TerminalHeader>

                        <TerminalList>
                            {terminals.filter((o) => o.EspelhoId === item.Id).map((terminal) =>
                                <Terminal
                                    key={terminal.Id}
                                    terminal={terminal}
                                    handleOpenBrowser={handleOpenBrowser}
                                    handleCloseBrowser={handleCloseBrowser}
                                    handleRefreshBrowser={handleRefreshBrowser}
                                    handleGetComports={handleGetComports}
                                    handleSetComport={handleSetComport}
                                    handleConnectComport={handleConnectComport}
                                    handleCloseComport={handleCloseComport}
                                    handleSendDataToComport={handleSendDataToComport}
                                />
                            )}
                        </TerminalList>

                    </AccordionDetails>
                </Accordion>
            )}

            <SetEspelhoLabelModal
                open={openLabelModal}
                handleClose={handleCloseLabelModal}
                selectedEspelho={selectedEspelho}
            />
            <AddTerminalModal
                open={openAddTerminalModal}
                handleClose={handleCloseAddTerminalModal}
                selectedEspelho={selectedEspelho}
            />
        </div>
    )
}
export default EspelhoList;